import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wPXGyuXt4NvXJUqkQZcNxB/_DSC0487.jpg',
    alt: 'Producción Audiovisual'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nG24N8Hco3uesvj6ez2bKp/4e9ae4a1-45c1-4244-924f-bf4fbb0d33a2.jpg',
    alt: 'Campañas Publicitarias'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eGyBgu3yfj7S5pUMfKGH6e/IMG_0578.jpg',
    alt: 'Equipo Profesional'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fuWxjwbxj5SDDK95Cifgou/IMG_0795.jpg',
    alt: 'Experiencias Gastronómicas'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nxfkV5PSKtazAfgko1Y8Ct/IMG_1815.jpg',
    alt: 'Proyectos Comerciales'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jrMpqJGxSLudkY43eEEBPQ/_MG_5340.jpg',
    alt: 'Activaciones de Marca'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nenLLjt9NSFs7whgNJF7E5/DJI_0136.jpg',
    alt: 'Fotografía Aérea'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tqzD4dtHri6Mwkb2BHVYhP/IMG_0488.jpg',
    alt: 'Producción Hotelera'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t4o6YkTtueV3n6JfWh6hzE/IMG_0673.jpg',
    alt: 'Experiencia de Marca'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8NW6SvFAMMsWqic78bmFw3/IMG_1147.jpg',
    alt: 'Campañas Automotrices'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [images.length]);
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };
  const handlePrevious = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  const handleNext = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  return <div className="relative w-full h-[70vh] md:h-[80vh] overflow-hidden bg-gray-900" data-id="element-74">
      <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-75">
        <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
        x: {
          type: 'spring',
          stiffness: 300,
          damping: 30
        },
        opacity: {
          duration: 0.5
        }
      }} className="absolute inset-0" data-id="element-76">
          <img src={images[currentIndex].url} alt={images[currentIndex].alt} className="w-full h-full object-cover" data-id="element-77" />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 via-transparent to-transparent" data-id="element-78" />
        </motion.div>
      </AnimatePresence>
      {/* Navigation Buttons */}
      <button onClick={handlePrevious} className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 backdrop-blur-md hover:bg-white/20 transition-all duration-300 group" aria-label="Previous image" data-id="element-79">
        <ChevronLeftIcon className="h-6 w-6 text-white group-hover:scale-110 transition-transform" data-id="element-80" />
      </button>
      <button onClick={handleNext} className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 backdrop-blur-md hover:bg-white/20 transition-all duration-300 group" aria-label="Next image" data-id="element-81">
        <ChevronRightIcon className="h-6 w-6 text-white group-hover:scale-110 transition-transform" data-id="element-82" />
      </button>
      {/* Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-3" data-id="element-83">
        {images.map((_, index) => <button key={index} onClick={() => {
        setDirection(index > currentIndex ? 1 : -1);
        setCurrentIndex(index);
      }} className="group relative" aria-label={`Go to image ${index + 1}`} data-id="element-84">
            <div className={`h-1 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-12 bg-white' : 'w-8 bg-white/40 group-hover:bg-white/60'}`} data-id="element-85" />
            {index === currentIndex && <motion.div className="absolute inset-0 h-1 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full" initial={{
          width: 0
        }} animate={{
          width: '100%'
        }} transition={{
          duration: 5,
          ease: 'linear'
        }} data-id="element-86" />}
          </button>)}
      </div>
      {/* Image Counter */}
      <div className="absolute top-8 right-8 z-10 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md" data-id="element-87">
        <span className="text-white text-sm font-medium" data-id="element-88">
          {String(currentIndex + 1).padStart(2, '0')} /{' '}
          {String(images.length).padStart(2, '0')}
        </span>
      </div>
    </div>;
};
export default ImageCarousel;